import {
  IDENTITY_ADJUSTMENTS,
  TransformKind,
  type AdjustmentsParams,
} from '@/core/document'
import type { EditSessionState } from '@/core/store/editSession'
import { selectSelectedNode } from '@/core/store/selectors'

export function selectSelectedAdjustments(state: EditSessionState): Readonly<AdjustmentsParams> {
  const node = selectSelectedNode(state)
  return node.transforms[TransformKind.Adjustments] ?? IDENTITY_ADJUSTMENTS
}
